import * as React from "react";

interface Notification {
    type: "success" | "error" | "warning",
    text: string
}

interface Alert {
    type: "success" | "error" | "warning",
    title: string,
    text: string,
    buttons?: {
        label: string,
        type: "main" | "main2" | "main3" | "cancel",
        cb?: Function,
    }[]
}

function notify( notification ) {
    appContext.notificationPut( notification );
}

var appContext;
function notifyListener(context) {
    appContext = context;
}

function alert( alert ) {
    appContext.alertPut( alert );
}

export {
    Notification,
    notify,
    notifyListener,
    Alert,
    alert
}


// WEBPACK FOOTER //
// ./src/services/notify.tsx